import { Table } from "../../__generated__/globalTypes";

const TABLE_ROUTES: Record<Table, string> = {
  [Table.Customer]: "/customer",
  [Table.Contact]: "/contact",
  [Table.CustomerAddress]: "/customer-address",
  [Table.Order]: "/order",
  [Table.OrderLine]: "/order",
  [Table.Task]: "/task",
  [Table.Visit]: "/visit",
  [Table.Product]: "/product",
  [Table.StockUnit]: "/stock-unit",
  [Table.Prospection]: "/prospection",
  [Table.MailMessage]: "/mail-messages",
  [Table.GivenCans]: "/given-can",
  [Table.PriceRule]: "/price-rule",
};

/**
 * Construit le lien vers la ressource ciblée par une notification.
 * Renvoie null si la notification est purement informative (table/objectId absents).
 */
export const notificationLink = (
  table?: Table | null,
  objectId?: number | null
): string | null => {
  if (!table || !objectId) return null;
  const route = TABLE_ROUTES[table];
  if (!route) return null;
  // MailMessage n'a pas de page détail : on renvoie vers la liste
  if (table === Table.MailMessage) return route;
  return `${route}/${objectId}`;
};
